/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomConfirmationDialog.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import appTheme from "../../assets/AppTheme/appTheme";

const CustomConfirmationDialog = ({
  open,
  onClose,
  dialogTitle,
  dialogContent,
  onConfirm,
  disableConfirmBtn = false,
  showForwardButton,
  onForward,
}) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>{dialogContent}</DialogContent>
      <DialogActions>
        <Button
          sx={{ ...appTheme.commonBtnStyle }}
          color="error"
          variant="contained"
          onClick={onClose}
          startIcon={<CloseIcon />}
        >
          Cancel
        </Button>
        {showForwardButton ? (
          <Button
            disabled={disableConfirmBtn}
            sx={{ ...appTheme.commonBtnStyle }}
            color="primary"
            variant="contained"
            onClick={onForward}
            startIcon={<CheckIcon />}
            autoFocus
          >
            Confirm & Forward
          </Button>
        ) : (
          <Button
            disabled={disableConfirmBtn}
            sx={{ ...appTheme.commonBtnStyle }}
            color="primary"
            variant="contained"
            onClick={onConfirm}
            startIcon={<CheckIcon />}
            autoFocus
          >
            Confirm
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

CustomConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  dialogTitle: PropTypes.node,
  dialogContent: PropTypes.node,
  onConfirm: PropTypes.func,
  disableConfirmBtn: PropTypes.bool,
  showForwardButton: PropTypes.bool,
  onForward: PropTypes.func,
};

export default CustomConfirmationDialog;
